import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PATHS } from './paths';
import ProtectedRoute from './ProtectedRoute';
import GuestRoute from './GuestRoute';
import AppShell from '../components/layout/AppShell';
import MemberLayout from '../components/layout/MemberLayout';

import LandingPage from '../pages/landing/LandingPage';
import DoctorsPage from '../pages/doctors/DoctorsPage';
import DoctorDetailPage from '../pages/doctors/DoctorDetailPage';
import LoginPage from '../pages/auth/LoginPage';
import SmsLoginPage from '../pages/auth/SmsLoginPage';
import RegisterPage from '../pages/auth/RegisterPage';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import HomePage from '../pages/home/HomePage';
import BookingPage from '../pages/booking/BookingPage';
import BookingSuccessPage from '../pages/booking/BookingSuccessPage';
import AppointmentsPage from '../pages/appointments/AppointmentsPage';
import AppointmentDetailPage from '../pages/appointments/AppointmentDetailPage';
import ReschedulePage from '../pages/appointments/ReschedulePage';
import NotificationsPage from '../pages/notifications/NotificationsPage';
import ClinicInfoPage from '../pages/clinic/ClinicInfoPage';
import ProfilePage from '../pages/profile/ProfilePage';
import EditProfilePage from '../pages/profile/EditProfilePage';
import ChangePasswordPage from '../pages/profile/ChangePasswordPage';

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        {/* Public */}
        <Route path={PATHS.landing} element={<LandingPage />} />
        <Route path={PATHS.doctors} element={<DoctorsPage />} />
        <Route path={PATHS.doctorDetail} element={<DoctorDetailPage />} />
        <Route path={PATHS.clinic} element={<ClinicInfoPage />} />

        {/* Logged-out only */}
        <Route element={<GuestRoute />}>
          <Route path={PATHS.login} element={<LoginPage />} />
          <Route path={PATHS.loginSms} element={<SmsLoginPage />} />
          <Route path={PATHS.register} element={<RegisterPage />} />
          <Route path={PATHS.forgotPassword} element={<ForgotPasswordPage />} />
        </Route>

        {/* Logged-in */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MemberLayout />}>
            <Route path={PATHS.home} element={<HomePage />} />
            <Route path={PATHS.appointments} element={<AppointmentsPage />} />
            <Route path={PATHS.profile} element={<ProfilePage />} />
          </Route>
          <Route path={PATHS.book} element={<BookingPage />} />
          <Route path={PATHS.bookingSuccess} element={<BookingSuccessPage />} />
          <Route path={PATHS.appointmentDetail} element={<AppointmentDetailPage />} />
          <Route path={PATHS.reschedule} element={<ReschedulePage />} />
          <Route path={PATHS.notifications} element={<NotificationsPage />} />
          <Route path={PATHS.profileEdit} element={<EditProfilePage />} />
          <Route path={PATHS.changePassword} element={<ChangePasswordPage />} />
        </Route>

        <Route path="*" element={<Navigate to={PATHS.landing} replace />} />
      </Route>
    </Routes>
  );
}
